<template>
  <div v-if="toastState.visible" class="toast" :class="`toast-${toastState.type}`">
    {{ toastState.message }}
  </div>
</template>

<script>
import toast from "@/utils/toast";

export default {
  name: "GlobalToast",
  computed: {
    toastState() {
      return toast.state;
    }
  }
};
</script>

<style scoped>
.toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  min-width: 220px;
  max-width: min(520px, 90vw);
  padding: 12px 14px;
  border-radius: 10px;
  color: #ffffff;
  font-size: 0.9375rem;
  line-height: 1.4;
  text-align: center;
  box-shadow: 0 10px 22px rgba(15, 30, 40, 0.2);
}

.toast-success {
  background: #1e9b62;
}

.toast-error {
  background: #d64545;
}
</style>
